import React from "react";
import ListView from "../../../../../shared/components/ListView";
import { HistoryTableColumns } from "../../../../../configs/products";
import HistoryTableRows from "./HistoryTableRows";
import { ProductTransactionFilterType } from "../../../../../configs/filterTypes";
import { ProductTransactionSortTypes } from "../../../../../configs/sortTypes";

interface TransactionProps {
  productId: string;
}

const TransactionHistory = ({ productId }: TransactionProps) => {
  return (
    <ListView
      url={`/products/${productId}/transactions/`}
      filterTypes={ProductTransactionFilterType}
      sortTypes={ProductTransactionSortTypes}
      rowElement={HistoryTableRows}
      tableColumns={HistoryTableColumns}
      textString="Tìm kiếm theo từ khóa Mã sản phẩm"
    />
  );
};

export default TransactionHistory;
